import config from "@/config"
import http from "@/utils/request"

export default {
	token: {
		url: `${config.API_URL}/api/app/token-auth/login`,
		name: "登录获取TOKEN",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	tenant: {
		url: `${config.API_URL}/api/abp/multi-tenancy/tenants/by-name`,
		name: '获取企业信息',
		get: async function (data = {}) {
			return await http.get(this.url + '/' + data, {});
		}
	},
	userInfo: {
		url: `${config.API_URL}/api/abp/application-configuration`,
		name: '获取个人权限信息',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	getUserInfo: {
		url: `${config.API_URL}/api/abp/application-configuration`,
		name: '获取个人权限信息',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	}
}
